import React, { useState } from 'react';
import axios from 'axios';

export default function ReceptionistForm() {
  const [form, setForm] = useState({
    to_phone: '',
    customer_name: '',
    purpose: '',
    message: '',
    preferred_time: '',
    customer_email: '',
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    try {
      const payload = { ...form };
      Object.keys(payload).forEach((k) => {
        if (payload[k] === '') delete payload[k];
      });
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/calls/receptionist`, payload);
      const callId = res.data?.result?.call_id || 'started';
      setStatus(`Call started! ID: ${callId}`);
      setForm({ to_phone: '', customer_name: '', purpose: '', message: '', preferred_time: '', customer_email: '' });
    } catch (err) {
      const msg = err.response?.data?.detail?.error || err.response?.data?.detail || err.message;
      setStatus(msg || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <div className="form-header">Receptionist flow: greet, identify purpose, collect essentials, and schedule callback.</div>
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="field">
            <label className="label">Customer Phone *</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.31 1.77.57 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.09a2 2 0 0 1 2.11-.45c.84.26 1.71.45 2.61.57A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2"/></svg></span>
              <input name="to_phone" type="tel" placeholder="+91 00000 00000" value={form.to_phone} onChange={handleChange} required />
            </div>
          </div>
          <div className="field">
            <label className="label">Customer Name *</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0" stroke="currentColor" strokeWidth="2"/></svg></span>
              <input name="customer_name" type="text" placeholder="e.g., Neha Verma" value={form.customer_name} onChange={handleChange} required />
            </div>
          </div>
        </div>
        <div className="form-grid">
          <div className="field">
            <label className="label">Purpose</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="2"/></svg></span>
              <select name="purpose" value={form.purpose} onChange={handleChange}>
                <option value="">Select purpose</option>
                <option>Sales</option>
                <option>Support</option>
                <option>Billing</option>
                <option>Logistics</option>
                <option>Careers</option>
                <option>Other</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label className="label">Preferred Callback Time (optional)</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2"/></svg></span>
              <input name="preferred_time" type="text" placeholder="e.g., Today 4–6 PM" value={form.preferred_time} onChange={handleChange} />
            </div>
          </div>
        </div>
        <div className="form-grid">
          <div className="field field-span-2">
            <label className="label">Message (optional)</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v14H7l-3 3V4z" stroke="currentColor" strokeWidth="2"/></svg></span>
              <textarea name="message" placeholder="Short note to help route the request" value={form.message} onChange={handleChange} />
            </div>
          </div>
        </div>
        <div className="form-grid">
          <div className="field field-span-2">
            <label className="label">Customer Email (optional)</label>
            <div className="input-group">
              <span className="icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 6h16v12H4z" stroke="currentColor" strokeWidth="2"/><path d="M4 6l8 7 8-7" stroke="currentColor" strokeWidth="2"/></svg></span>
              <input name="customer_email" type="email" placeholder="customer@example.com" value={form.customer_email} onChange={handleChange} />
            </div>
          </div>
        </div>
        <div className="button-row">
          <button type="submit" disabled={loading}>{loading ? 'Calling…' : 'Submit Request'}</button>
        </div>
      </form>
      {status && <p className={`status ${status.toLowerCase().includes('call') ? 'success' : 'error'}`}>{status}</p>}
    </div>
  );
}
